var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialIcnFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_256_859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 14C28 6.26808 21.7319 0 14 0C6.26808 0 0 6.26808 0 14C0 20.5654 4.52032 26.0747 10.6182 27.5878V18.2784H7.73136V14H10.6182V12.1565C10.6182 7.39144 12.7747 5.1828 17.453 5.1828C18.34 5.1828 19.8705 5.35696 20.4966 5.53056V9.40856C20.1662 9.37384 19.5922 9.35648 18.8793 9.35648C16.5838 9.35648 15.6968 10.2262 15.6968 12.4869V14H20.2698L19.4841 18.2784H15.6968V27.8975C22.629 27.0603 28.0006 21.1579 28.0006 14H28Z",
    fill: "#0866FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4835 18.2782L20.2692 13.9998H15.6962V12.4867C15.6962 10.226 16.5833 9.3563 18.8787 9.3563C19.5916 9.3563 20.1656 9.37366 20.496 9.40838V5.53038C19.8699 5.35622 18.3394 5.18262 17.4524 5.18262C12.7742 5.18262 10.6176 7.39126 10.6176 12.1563V13.9998H7.7308V18.2782H10.6176V27.5877C11.7006 27.8565 12.8335 27.9998 13.9994 27.9998C14.5734 27.9998 15.1396 27.9645 15.6957 27.8973V18.2782H19.483H19.4835Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_256_859"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcnFb);
export default __webpack_public_path__ + "static/media/social-icn-fb.0fe4fcb249a8cf524537d6422d10a09d.svg";
export { ForwardRef as ReactComponent };